import * as api from 'api/auth'
import { signedOut, signedUp, signedIn } from 'utils/mixpanel'

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const SIGN_IN = 'SIGN_IN'
export const SIGN_UP = 'SIGN_UP'
export const SIGN_OUT = 'SIGN_OUT'

export const changePassword = (password, passwordConfirmation) => ({
  type: CHANGE_PASSWORD,
  payload: api.changePassword(password, passwordConfirmation)
})

export const signIn = (email, password) => ({
  type: SIGN_IN,
  payload: api.signIn(email, password).then(trackSignIn)
})

// TODO: tracking from within action creators give us the advantage of
// consolidating our tracking requests but at the same time, introduces
// side effects. This is alright for now but should eventually get moved
// into middleware that will listen for certain actions and fire callbacks
// as necessary
export const signInWithFacebook = (fbAccessToken) => ({
  type: SIGN_IN,
  payload: api.signInWithFacebook(fbAccessToken).then(trackSignIn)
})

export const signUpWithFacebook = (fbAccessToken, communityId) => ({
  type: SIGN_UP,
  payload: api.signUpWithFacebook(fbAccessToken, communityId).then(trackSignUp)
})

export const signInWithGoogle = (googleIdToken) => ({
  type: SIGN_IN,
  payload: api.signInWithGoogle(googleIdToken).then(trackSignIn)
})

export const signUpWithGoogle = (googleIdToken, communityId) => ({
  type: SIGN_UP,
  payload: api.signUpWithGoogle(googleIdToken, communityId).then(trackSignUp)
})

export const signUp = data => ({
  type: SIGN_UP,
  payload: api.signUp(data).then(trackSignUp)
})

export const signOut = () => ({
  type: SIGN_OUT,
  payload: api.signOut().then((response) => {
    signedOut()
    return response
  })
})

const trackSignIn = response => {
  const userId = response.data.result
  signedIn(userId)
  return response
}

const trackSignUp = (response) => {
  const { data: { result, entities: { users } } } = response
  signedUp(users[result])
  return response
}
